import { Color3, Vector3 } from 'babylonjs';

export const MAIN_LIGHT_NAME = 'mainLight';

// (0 0 -1) points the north
export const NORTH_VECTOR = new Vector3(0, 0, -1);
export const HORIZON_VECTOR = new Vector3(1, 0, 0);

export const ELECTRIC_BLUE_COLOR = '#56CCFF';
export const ELECTRIC_BLUE_COLOR3 = Color3.FromHexString(ELECTRIC_BLUE_COLOR);
export const BASE_MATERIAL_NAME = 'baseMaterial';
export const ELECTRIC_BLUE_MATERIAL_NAME = 'electricBlueMaterial';
export const RED_MATERIAL_NAME = 'redMaterial';
export const GREEN_LIGHT_MATERIAL_NAME = 'greenLightMaterial';
export const RED_LIGHT_MATERIAL_NAME = 'redLightMaterial';
export const YELLOW_LIGHT_MATERIAL_NAME = 'yellowLightMaterial';
export const DARK_BLUE_MATERIAL_NAME = 'darkBlueMaterial';
export const DRAG_MESH_MATERIAL_NAME = 'dragMeshMaterial';
export const BLACK_COLOR = '#000000';
export const WHITE_COLOR = '#ffffff';
export const DRAG_MESH_COLOR = '#ff4f00';
export const GREY_COLOR = '#aaa8ab';

// model
export const MODEL_NAME = 'model';
export const MODEL_MESH_NAME = 'modelMesh';

export const MODEL_AT_NAME = 'modelAT';

// babylon gui
export const FILLING_COLOR_PLANE_NAME = 'fillingColorPlane';
export const FILLING_PLANE_MATERIAL_NAME = 'fillingPlaneMaterial';
export const KNOT_MATERIAL_NAME = 'knotMaterial';

// basePlane config
export const BASE_PLANE_NAME = 'basePlane';
export const DIRECTIONAL_LIGHT_NAME = 'directionalLight';

// measurements config
export const MEASUREMENT_NAME = 'measurement';
export const NEW_MEASUREMENT_NAME = 'newMeasurement';
export const MIDDLE_SPHERE_NAME = 'middleSphere';

// cuboidObject config
export const CUBOID_OBJECT_NAME = 'cuboid';
export const CUBOID_PICKER_NAME = 'cuboidPicker';

// annotation config
export const ANNOTATION_NAME = 'annotation';

// rectTubeObject config
export const RECT_TUBE_OBJECT_NAME = 'rectTube';

// polygon config
export const POLYGON_MESH_BUILDER_NAME = 'polygonMeshBuilder';
export const CENTER_SPHERES_CONTAINER_NAME = 'Center Spheres';
export const PICKER_SPHERES_CONTAINER_NAME = 'Picker Spheres';
export const POLYGON_PICKER_SPHERE_NAME = 'pickerSphere';
export const PICKER_SPHERE_MATERIAL_NAME = 'pickerSphereMaterial';
export const NEW_POLYGON_NAME = 'newPolygon';
export const POLYGON_NAME = 'Polygon';
/**
 *   centerSphereName used for creating
 *   description in the polygon center
 */
export const CENTER_SPHERE_NAME = 'centerSphere';

// sketchPlanes config
export const SKETCH_PLANE_NAME = 'sketchPlane';
export const SKETCH_POLYGON_NAME = 'sketchPolygon';
export const SKETCH_PLANE_SPHERE_NAME = 'sketchPlaneSphere';
export const SKETCH_POLYGON_SPHERE_MAT_NAME = 'sketchPolygonSphereMat';
export const SKETCH_POLYGON_MAT_NAME = 'sketchPolygonMat';
export const SKETCH_PLANE_GRID_MAT_NAME = 'sketchPlaneGridMat';
export const FILLING_PLANE_MAT_NAME = 'fillingPlaneMat';
export const FILLING_COLOR_SKETCH_PLANE_NAME = 'fillingColorSketchPlane';
export const GRID_SKETCH_PLANE_NAME = 'gridSketchPlane';
export const SKETCH_PLANES_SIZE = 40;

// common sketch configs
export const LOD_BOX_SIZE_NAME = 'lodMeshSize_';
export const LOD_BOXES_CONTAINER_NAME = 'lodMeshes';
export const SKETCH_MESHES_CUSTOM_SCALE = 'sketchMeshesCustomScale';
export const UPWARD_VECTOR = new Vector3(0, 1, 0);
export const DOWNWARD_VECTOR = new Vector3(0, -1, 0);
export const SKETCH_MESHES_MATERIAL_NAME = 'sketchMeshesMat';
export const SKETCH_DRAG_MESHES_MATERIAL_NAME = 'sketchDragMeshesMat';
export const SKETCH_POINTER_NAME = 'sketchPointer';

// sketchLines config
export const DRAFT_SKETCH_LINE_TAG_NAME = 'draftSketchLineTag';
export const SKETCH_LINE_BOX_TAG_NAME = 'sketchLineBoxTagName';
export const NEW_SKETCH_LINE_NAME = 'newSketchLine';
export const SKETCH_LINE_NAME = 'sketchLine';
export const SKETCH_LINE_BOX_NAME = 'sketchLineBox';
export const SKETCH_LINE_MESH_NAME = 'lineMesh';
export const SKETCH_LINE_POINTER_NAME = 'sketchLinePointer';

// sketchRectangle config
export const DRAFT_SKETCH_RECTANGLE_TAG_NAME = 'draftSketchLineTag';
export const NEW_SKETCH_RECTANGLE_NAME = 'newSketchRectangle';
export const SKETCH_RECTANGLE_NAME = 'sketchRectangle';
export const SKETCH_RECTANGLE_BOX_NAME = 'sketchRectangleBox';
export const SKETCH_RECTANGLE_POINTER_NAME = 'sketchRectanglePointer';

// sketchCircle config
export const NEW_SKETCH_CIRCLE_NAME = 'newSketchCircle';
export const DRAFT_SKETCH_CIRCLE_TAG_NAME = 'draftSketchCircleTag';
export const SKETCH_CIRCLE_MESH_NAME = 'circleMesh';
export const SKETCH_CIRCLE_CENTER_MESH_NAME = 'centerMesh';
export const SKETCH_CIRCLE_EDGE_MESH_NAME = 'edgeMesh';
export const SKETCH_CIRCLE_MESHES_TAG_NAME = 'sketchCircleMeshesTagName';
export const VECTOR_LENGTH = 99; // picking/finding the plane meters range

export const CAMERA_MESH_NAME = 'cameraPointMesh';
export const DECAL_NAME = 'decal';
